module.exports = __webpack_public_path__ + "img/sgp_mlc.b2721ece.jpg";